import { openModal } from 'features/modal/modalSlice';
import { selectRequireRemoveUserConfirmation } from 'features/room/roomSlice';
import { kickUser, kickUserRequested } from 'features/users/actions';
import { put, select } from 'redux-saga/effects';
import {
  selectBreakoutRoomsStatus,
  selectUserBreakoutRoomId,
} from 'features/breakout-rooms/breakoutRoomsSlice';
import { BreakoutRoomsStatus } from 'features/breakout-rooms/types';

export function* onKickUserRequestedSaga(action: ReturnType<typeof kickUserRequested>) {
  const userId = action.payload;

  const requireConfirmation: boolean = yield select(selectRequireRemoveUserConfirmation);

  const breakoutId: string | undefined = yield select(selectUserBreakoutRoomId, userId);
  const breakoutsStatus: BreakoutRoomsStatus = yield select(selectBreakoutRoomsStatus);
  const breakoutsStarted = breakoutsStatus === 'started';

  if (requireConfirmation) {
    yield put(
      openModal('kickUserConfirmation', {
        userId,
        breakoutId: breakoutsStarted ? breakoutId : undefined,
      })
    );
  } else {
    yield put(
      kickUser({
        userId,
        breakoutId: breakoutsStarted ? breakoutId : undefined,
      })
    );
  }
}
